// ==============================|| OVERRIDES - DRAWER ||============================== //
export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: ({ ownerState }) => ({
          backgroundColor: '#F4F5F5',
          ...(ownerState.variant === 'temporary' && {
            boxShadow: theme.shadows[8],
          }),

          ...(ownerState.variant === 'permanent' && {
            borderRight: 'none',
          }),

          ...(ownerState.variant === 'persistent' && {
            borderRight: `2px solid #9a0007`,
          }),
        }),
      },
    },
  };
}
